import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.googleAnalyticsID;
  document.head.appendChild(script);
} else {
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.googleAnalyticsID;
  document.head.appendChild(script);
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    // eslint-disable-next-line no-console
    .catch(err => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap, { passive: true });
}
